export const RESULT_CODE = {
  /**
   * 全局限流
   */
  GLOBAL_RATE_LIMITING: 429,

  /**
   * 预约锁，稍后再试
   */
  RESERVE_LOCKED: 42121,
};
